export const RAW_FEED_EMPTY_MESSAGE = (
  "Nessun feed raw salvato. Imposta formato, header e GDrive, poi clicca «Scarica feed raw» oppure «Carica feed raw»."
);

export const MAPPING_TAB_EMPTY_MESSAGE = (
  "Nessun feed normalizzato disponibile. Apri «Acquisizione feed», scarica o carica il feed raw e clicca «Normalizza», poi torna in «Revisione e Mapping»."
);

export const resolveMappingTabStatus = ({
  previewError,
  previewLoading,
  preview,
}) => {
  if (previewError) {
    return { severity: "warning", text: previewError };
  }
  if (previewLoading) {
    return null;
  }
  if (preview?.total_rows > 0) {
    return null;
  }
  if (preview?.message) {
    return { severity: "info", text: preview.message };
  }
  return { severity: "info", text: MAPPING_TAB_EMPTY_MESSAGE };
};
